import React from "react";
import { Drawer, ThemeProvider } from "@material-tailwind/react";

type DrawerProps = {
  isOpen: boolean
  closeDrawer: () => void
  children: React.ReactNode
}
export function DrawerBase(props: DrawerProps) {
  return (
    <>
      <ThemeProvider value={{
        drawer: {
          styles: {
            base: {
              overlay: {
                position: "fixed",
                width: null,
                height: null
              }
            }
          }
        }
      }}>
        <Drawer
          placement={"right"}
          size={320}
          open={props.isOpen}
          onClose={props.closeDrawer}
          className="bg-main/75 border-l border-gray-600"
        >
          {props.children}
        </Drawer>
      </ThemeProvider>
    </>
  );
}